// extracted by mini-css-extract-plugin
var _1 = "pWeYOTzbiQPs_vhEaD6u";
var _2 = "gf5h9VyUJtVZiYBi1MIh";
export { _1 as "withRoomForHeader", _2 as "withoutRoomForHeader" }
